import { Link, useSearchParams } from 'react-router-dom';
import { AuthShell } from './Login';
import { Button } from '../components/ui';

const REASONS: Record<string, string> = {
  token_missing: 'The sign-in link was incomplete. Request a new one.',
  token_invalid_or_expired: 'That sign-in link is invalid or has expired. Links last 15 minutes and work once.',
};

export default function AuthError() {
  const [params] = useSearchParams();
  const reason = params.get('reason') ?? '';
  return (
    <AuthShell title="Sign-in link problem">
      <div className="space-y-5 text-center">
        <div className="text-5xl">⚠️</div>
        <p className="text-sm text-slate-600">{REASONS[reason] ?? 'We could not complete sign-in. Please try again.'}</p>
        <Link to="/auth/login">
          <Button className="w-full">Request a new link</Button>
        </Link>
      </div>
    </AuthShell>
  );
}
